export const COMMON = {
  EMPTY: 'is_null', // 为空
  NOT_EMPTY: 'not_null' // 不为空
}

// 填空
export const INPUT = {
  INCLUDE: 'like', // 包含
  NOT_INCLUDE: 'not_like', // 不包含
  EQUAL: 'eq', // 等于
  NOT_EQUAL: 'not_eq' // 不等于
}

// 单选
export const SELECT = {
  SELECTED: 'in', // 选中
  NOT_SELECTED: 'not_in' // 未选中
}

// 多选
export const MULTI_SELECT = {
  INCLUDE: 'like', // 包含
  NOT_INCLUDE: 'not_like', // 未包含
  SELECTED: 'in', // 只选中
  NOT_SELECTED: 'not_in' // 未选中
}

// 级联
export const CASCADER = SELECT

// 数字
export const NUMBER = {
  EQUAL: 'eq', // 等于
  NOT_EQUAL: 'not_eq', // 不等于
  GREATER: 'gt', // 大于
  GREATER_OR_EQUAL: 'ge', // 大于或等于
  LESS: 'lt', // 小于
  LESS_OR_EQUAL: 'le', // 小于或等于
  BETWEEN: 'between', // 介于（含等于）
  NOT_BETWEEN: 'not_between' // 不介于
}

// 日期
export const DATE = {
  EQUAL: 'eq', // 等于
  NOT_EQUAL: 'not_eq', // 不等于
  BEFORE: 'lt', // 早于
  BEFORE_OR_EQUAL: 'le', // 早于或等于
  AFTER: 'gt', // 晚于
  AFTER_OR_EQUAL: 'ge', // 晚于或等于
  BETWEEN: 'between', // 介于（含等于）
  NOT_BETWEEN: 'not_between' // 不介于
}

// 地址
// 地址类型
export const ADDRESS_TYPES = {
  PROVINCE: 1, // 省份 'province'
  CITY: 2, // 城市 'city'
  COUNTY: 3, // 区/县 'county'
  DETAILED_ADDRESS: 4 // 详细地址 detailedAddress'
}
